import { userId } from '@state'
import { createQuery } from '@tanstack/solid-query'
import { type Component, Show, createSignal } from 'solid-js'
import { apiClient } from '../utils/api-client'

const UserTest: Component = () => {

  const userId = 'd61609aa-ac3d-40e8-bf13-538cb1b09ec9'

  // Workaround for ts-rest solid-query v5 incompatibility: use manual createQuery with vanilla client
  const profile = createQuery(() => ({
    queryKey: ['profile', userId],
    queryFn: async () => {
      console.log('Fetching profile for userId:', userId)
      const result = await apiClient.getProfile({ params: { userId: userId } })
      console.log('API Result:', result)

      if (result.status !== 200) {
        // If it's an error, log it clearly
        console.error('API Error Body:', result.body)
        throw result.body
      }
      return result
    }
  }))

  return (
    <div style={{ padding: '20px', "font-family": 'sans-serif' }}>
      <h2>Fastify + ts-rest + Solid Query</h2>

      <div style={{ "margin-bottom": '20px' }}>
        {/* biome-ignore lint/a11y/noLabelWithoutControl: <explanation> */}
        <label>User ID: </label>
        {userId}
      </div>

      <Show when={profile.isLoading}>
        <p>Loading...</p>
      </Show>

      <Show when={profile.error}>
        <p style={{ color: 'red' }}>Error: {JSON.stringify(profile.error, Object.getOwnPropertyNames(profile.error))}</p>
      </Show>

      <Show when={profile.data}>
        {(data) => (
          <div style={{ border: '1px solid #ccc', padding: '10px', "border-radius": '4px' }}>
            <h3>Response Status: {data().status}</h3>
            <pre style={{ background: '#f5f5f5', padding: '10px' }}>
              {JSON.stringify(data().body, null, 2)}
            </pre>

            {/* Type safety demonstration - accessing property from database type */}
            {data().status === 200 && (
              <p>
                <strong>Username (Typed):</strong> {data().body.username}
              </p>
            )}
          </div>
        )}
      </Show>
    </div>
  )
}

export default UserTest
